import { Box, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { IconLockAccess } from '@tabler/icons-react';
import { EmptyState } from '@fololabs/design/components';
import { LauncherShell } from '../components/LauncherShell';
import { ProductTile } from '../components/ProductTile';
import { accessibleProducts } from '../products';

interface Props {
  email: string;
  groups: string[];
  onSignOut: () => void;
}

export function LaunchpadPage({ email, groups, onSignOut }: Props) {
  const products = accessibleProducts(groups);

  return (
    <LauncherShell email={email} onSignOut={onSignOut}>
      <Stack gap="xl">
        <Box>
          <Title order={2} c="aquifer.7">
            Your products
          </Title>
          <Text size="sm" c="dimmed" mt={4}>
            Select a product to continue — you stay signed in across all
            FoloLabs apps.
          </Text>
        </Box>

        {products.length === 0 ? (
          <EmptyState
            icon={IconLockAccess}
            title="No products yet"
            description="Your account doesn't have access to any FoloLabs products. Contact your administrator to request access."
          />
        ) : (
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            {products.map((p) => (
              <ProductTile key={p.id} product={p} />
            ))}
          </SimpleGrid>
        )}
      </Stack>
    </LauncherShell>
  );
}
